import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { IContentPublishOptions } from "../../interfaces/content-publish-options.interface";

@Injectable()
export class BlogArticleService {
  private apiPrefix = '/admin/blog-articles';

  constructor(
    private api: ApiService
  ) {
  }

  createArticle(data: object) {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  updateArticle(id: number, data: object) {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteArticle(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  getArticles(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`,);
  }

  publish(id: number, opts: IContentPublishOptions) {
    const body = {
      notify: opts.notify
    };
    if (opts?.publishDate)
      body['publishDate'] = opts.publishDate;

    return this.api.patch(`${this.apiPrefix}/${id}/publish`, body);
  }

  unpublish(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/unpublish`, {});
  }

  createImage(id: number, data: object) {
    return this.api.post(`${this.apiPrefix}/${id}/image`, data);
  }

  saveImage(id: number, requestId: string) {
    return this.api.patch(`${this.apiPrefix}/${id}/image/${requestId}`, {});
  }

  getRelatedVideo(id: number) {
    return this.api.get(`${this.apiPrefix}/${id}/related-video`);
  }

  attachRelatedVideo(id: number, videoId: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/related-video`, {videoId});
  }

  unAttachRelatedVideo(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}/related-video`);
  }
}
